export const FILTER_TYPE = {
    custom: "custom",
    default: "default",
    basic: "basic",
};
